export const environmentBase = {
  production: false,
  slimPackage: 'disabled',
  siteUrl: 'http://dev.apsis:4200/',
  oneUrl: 'https://one.fe-stage.apsis.cloud/',
  apiBaseUrl: 'https://gw.au-stage.apsis.cloud/backoffice/',
  audienceBaseUrl: 'https://pub.aud-stage.apsis.cloud/st/',
  avatarBaseUrl: 'https://avatar.au-stage.apsis.cloud/',
  emailBaseUrl: 'https://pub.email-stage.apsis.cloud/',
  proSyncBaseUrl: 'https://gw.prosync-stage.apsis.cloud/backoffice/',
  smsBaseUrl: 'https://gw.sms-stage.apsis.cloud/',
  maBaseUrl: 'https://6ev7c9az4d.execute-api.eu-west-1.amazonaws.com/dev/',
  ecomBaseUrl: 'https://gw.ecom-stage.apsis.cloud/',
  integrationsBaseUrl: 'https://integrations-stage.apsis.cloud/',
  webVersionUrl: 'https://web-stage.apsis.cloud/preview/',
  privateDomainUrl: 'https://pub.private-domain-stage.apsis.cloud/',
  auth0: {
    clientID: 'DiW8RQZ73MoMi2n65AmhGsgxuJ1NGyyQ',
    domain: 'apsis-one-stage.eu.auth0.com',
    audience: 'https://apsis.one/support',
    issuer: 'https://apsis-one-stage.eu.auth0.com',
    tenant: 'apsis-one-stage',
  },
};
